export default __webpack_public_path__ + "static/media/die.c4ea9d46.png";